import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect,useContext } from 'react';
import Axios from 'axios';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
//import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { Paper } from "@mui/material";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MuiAlert from '@mui/material/Alert';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

import { urlConfig } from "../config"; 

import CreateTab from './CreateTab';

const ariaLabel = { 'aria-label': 'description' };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const AccessPortal = () => {
    const [userList,setUserList] = useState([]);
    const [data,setData] = useState({});
    const [edit,setEdit]= useState(false);
    const [error,setError]=useState(false);
    const [confirm,setConfirm]=useState(false);
    const [confirmEdit,setConfirmEdit]=useState(false);
    const [confirmDelete,setConfirmDelete]=useState(false);
    const [create,setCreate]= useState(false);
    const [createTab,setCreateTab]= useState(false);
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);
    const [selectAll,setSelectAll] = useState(false);
    const [name,setName]=useState('');
    const [email,setEmail] = useState('');
    const [country,setCountry] = useState('');
    const [team,setTeam] = useState('');
    const [tab,setTab] = useState([]);
    const [tabsallowed,settabsallowed] = useState('');
    const [deleteRecord,setDeleteRecord] = useState({});
    const [names,setNames] = useState([]);
    const [userEmail,setUserEmail]=useState('');


    const columns = [
        { field: 'id', headerName: 'User ID', width: 70, headerAlign: 'center', align: 'center'  }, 
        { field: 'username', headerName: 'User Name', width: 130, },
        { field: 'emailid', headerName: 'Email', width: 200,  },
        {
          field: 'country',
          headerName: 'Country',
          width: 90,
        },
        {
          field: 'team',
          headerName: 'Team',
          description: 'This column has a value getter and is not sortable.',
          width: 90,
        },
        {
          field: 'tabsallowed',
          headerName: 'Tab',
          width: 90,
        },
        { 
            field: "Edit",
      headerName: "Edit",
      width: 90,
      renderCell: (params) => {
        return (
          <Button
            onClick={() => editButton(params.row)}
          >
            Edit
          </Button>
        );
      }
        },
        { 
          field: "Delete",
    headerName: "Delete",
    width: 90,
    renderCell: (params) => {
      return (
        <Button
          onClick={() => deleteButton(params.row)}
        >
          Delete
        </Button>
      );
    }
      },
      ];

     
//-------------API call---------------//

useEffect(()=>{
  setUserEmail(sessionStorage.getItem("userEmail"));
  Axios.get(`${urlConfig.cmsURL}/api/users/getallusers`)
  .then((res)=>{
      setUserList(res.data);
  })
  Axios.get(`${urlConfig.cmsURL}/api/tabs/getallTabs`)
  .then((res)=>{
    setNames(res.data);
  })
},[])

const handleSubmitCreate = (e) => {
  e.preventDefault();
  Axios.post(`${urlConfig.cmsURL}/api/users/addUsers?email=${userEmail}`,
  {
      username: name,
      emailid: email,
      team: team,
      country: country,
      tabsallowed: tabsallowed
  })
  .then((res)=>{
    setSuccess(true);
    setMessage(res.data.message);
    setName('');
    setName('');
    setEmail('');
    setCountry('');
    setTeam('');
    setTab([]);
    settabsallowed('');
  })
  .catch((err)=>{
    setMessage("Facing error");
    setError(true);

  })

  setConfirm(false)
  setCreate(false);

}

const handleSubmitEdit = (e) => {
  e.preventDefault();
  Axios.put(`${urlConfig.cmsURL}/api/users/updateUser?email=${userEmail}`,
  data)
  .then((res)=>{
    console.log(res.data.message)
    setConfirmEdit(false);
    setMessage(res.data.message);
    setSuccess(true);
    setEdit(false);
  })
  .catch((err)=>{
    setMessage("Facing error")
    setError(true)
    setConfirmEdit(false)
  })
}

const handleDelete = (e) => {
  e.preventDefault();
  Axios.delete(`${urlConfig.cmsURL}/api/users/deleteUser/${deleteRecord.id}?email=${userEmail}`)
  .then((res)=>{
    setMessage(res.data.message)
    setSuccess(true);
  })
  .catch((err)=>{
    setMessage("Facing error")
    setError(true)
  })
  const updatedData = userList.filter(i => i.id !== deleteRecord.id);
  setUserList(updatedData);
  setConfirmDelete(false);


}

 //------------function-----------------------------------//
  
 const handleChange = (event) => {
  setTab(event.target.value)
  settabsallowed(event.target.value.toString())
};

const handleSuccess = (e) => {
setMessage(e)
setSuccess(true)
}

const handleError = (e) => {
setMessage(e)
setError(true)
}

const handleSelectAll = (event) => {
const checked = event.target.checked;
setSelectAll(checked);
if(!selectAll) {
  const filterTab = names.map((e)=>{
    return e.tabId
  })
setTab(filterTab);
settabsallowed(filterTab.toString())
} else {
  setTab([]);
  settabsallowed('');
}

}

const handleCreateButton = () => {
    setCreateTab(true);
}

const handleCreateButtonClose = () => {
setCreateTab(false);
}

const handleClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }

  setSuccess(false);
  setError(false);
  setMessage('');
};

function editButton  (params)  { 
console.log(params)
setCreate(false);
setTab(params.tabsallowed.split(','))
settabsallowed(params.tabsallowed)
setData(params)
setEdit(true)
}

function deleteButton  (params)  { 
setDeleteRecord(params);
setConfirmDelete(true)
}

const handleConfirm = (e) => {
e.preventDefault();
if(email=='' || name=='' || team=='' || country=='' || tab.length === 0) {
  setMessage('All fields are mandatory..!!')
  setError(true);
} else{
setConfirm(true)
} 

}

const handleConfirmEdit = (e) => {
  e.preventDefault();
  console.log(data.username,data.emailid,data.country,data.team,data.tabsallowed);
  if(data.username.trim()===''||data.emailid.trim()===''||data.country.trim()===''|| data.team.trim()===''||data.tabsallowed.trim()==='') {
    setMessage('All fields are mandatory..!!')
    setError(true);
  } else{
    setConfirmEdit(true);
  } 
}

const handleCreate = () => {
  setEdit(false)
  setCreate(true)

}

//------------Edit function  --------------------//

const handleChangeName = (e) => {
  setData({...data,username:e.target.value})
}

const handleChangeEmail = (e) => {
  setData({...data,emailid:e.target.value})
}
const handleChangeCountry = (e) => {
  setData({...data,country:e.target.value})
}

const handleChangeTeam = (e) => {
  setData({...data,team:e.target.value})
}

const handleChangeTab = (e) => {
  console.log(e.target.value.toString());
  setTab(e.target.value);
  setData({...data,tabsallowed:e.target.value.toString()})
}


  return (
    <>
    <Stack sx={{ ml:3,mt:2 }} direction='row' spacing={2}>  
    <Button onClick={handleCreate} variant="contained" >Create new access</Button>
    <Button  variant="contained" onClick={handleCreateButton} >Tab Details</Button>
    <Button onClick={()=>{window.location.reload(false);}} variant="contained" >Refresh</Button>
    </Stack>

    <Dialog open={confirmEdit}>
          <DialogTitle>Are you sure.You want to update it?</DialogTitle>
          <DialogActions>
            <Button onClick={handleSubmitEdit} >Confirm</Button>
            <Button onClick={()=>setConfirmEdit(false)}>Cancel</Button>
          </DialogActions>
        </Dialog>


      <Dialog
      open={confirm}
      >
       <DialogTitle>
       Are you sure. You want to submit?
      </DialogTitle>
      <DialogActions> 
          <Button onClick={handleSubmitCreate} autoFocus>
            Submit
          </Button>
          <Button onClick={()=>setConfirm(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
      {createTab && <div>
        <CreateTab handleSuccess={handleSuccess} handleError={handleError} handleCreateButtonClose={handleCreateButtonClose} />
        </div>}

    {create && <div>
      <DialogTitle>Create new access</DialogTitle>
  
        <Box
      component="form"
      sx={{
        '& > :not(style)': { m: 1 },
      }}
      onSubmit={handleConfirm}
      noValidate
      autoComplete="off"
      required
    >
      <TextField sx={{ width: 300 }} onChange={(e)=>{setName(e.target.value)}}  label="username" value={name} required />
      <TextField sx={{ width: 300 }} label="email" onChange={(e)=>{setEmail(e.target.value)}} value={email} required  />
      <TextField onChange={(e)=>{setCountry(e.target.value)}} label="country" value={country} required  />
      <TextField onChange={(e)=>{setTeam(e.target.value)}} label="Team" value={team} required  />
      <FormControl sx={{ width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">Tab</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={tab}
          onChange={handleChange}
          input={<OutlinedInput label="Tab" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          required
        
        >
          <FormControlLabel 
               control={
                <Checkbox checked={selectAll}
                onChange={handleSelectAll}/>
               }
               label="Select all"
          />
          {names.map((name) => (
            <MenuItem key={name.id} value={name.tabId}>
              <Checkbox checked={tab.indexOf(name.tabId) > -1} />
              <ListItemText primary={name.tabName} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button  type='submit' variant='contained' >Submit</Button>
      <Button onClick={(e)=>(setCreate(false))} variant='contained' >Cancel</Button>
    </Box>
      </div>}
    {edit && <div>
      <DialogTitle>Edit</DialogTitle>
        <Box
      component="form"
      onSubmit={handleConfirmEdit}
      
      sx={{
        '& > :not(style)': { m: 1 },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField defaultValue={data.username} onChange={handleChangeName}  label="Username" />
      <TextField defaultValue={data.emailid} label="Email" onChange={handleChangeEmail}  />
      <TextField defaultValue={data.country} onChange={handleChangeCountry} label="Country"  />
      <TextField defaultValue={data.team} onChange={handleChangeTeam} label="Team"  />
    <FormControl sx={{ width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">Tab</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={tab}
          onChange={handleChangeTab}
          input={<OutlinedInput label="Tab" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          required
        
        >
          {names.map((name) => (
            <MenuItem key={name.id} value={name.tabId} >
              <Checkbox checked={tab.indexOf(name.tabId) > -1} />
              <ListItemText primary={name.tabName} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button type='submit'>submit</Button>
      <Button onClick={()=>{setEdit(false); setTab([])}}>Cancel</Button>
    </Box>
          
      </div>}
      
       <Dialog open={confirmDelete}>
          <DialogTitle>Are you sure.You want to delete it?</DialogTitle>
          <DialogActions>
            <Button onClick={handleDelete} >Confirm</Button>
            <Button onClick={()=>setConfirmDelete(false)}>Cancel</Button>
          </DialogActions>
        </Dialog>
      
      
    { !edit && !createTab && <Paper sx={{ height: 450, width: '100%',ml:3,mt:2, p:5 }}>
      <DataGrid
        rows={userList}
        columns={columns}
        pageSize={20}
        rowsPerPageOptions={[20]}
        
      />
    </Paper>}

    <Snackbar open={success} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
        {message}
        </Alert>
</Snackbar>
<Snackbar open={error} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
        {message}
        </Alert>
</Snackbar>
    </>
    
  );
}

export default AccessPortal